import { APIClient } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export class BlobClient extends APIClient {
    public static readonly endpoint = '/blob-api/v1';

    public static async fetchBlob(accountId: string, entityType: EntityType, entityId: string): Promise<Blob> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}?output=stream`);
        return await this.handleBlobResponse(response);
    }

    public static async fetchBlobWithFilename(accountId: string, entityType: EntityType, entityId: string): Promise<{ blob: Blob; filename: string | null }> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}?output=stream`);
        const filename = this.extractFilename(response);
        const blob = await this.handleBlobResponse(response);
        return { blob, filename };
    }

    public static async postBlob(accountId: string, entityType: EntityType, entityId: string, file: File): Promise<void> {
        const formData = new FormData();
        formData.append('file', file);
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}`, formData);
        return await this.handleVoidResponse(response);
    }

    public static async deleteBlob(accountId: string, entityType: EntityType, entityId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}`);
        return await this.handleVoidResponse(response);
    }
}
